<div class="notifications">
  <div class="header">
    <span class="header__label">Notifications</span>
    @if (notifications().length > 0) {
      <div class="header__alert">
        <span class="header__alert-label">{{ notificationsCount() }} new</span>
      </div>
    }
  </div>
  <div class="message">
    @for (notification of notifications(); let i = $index; track i) {
      @if (i < 4 || showMore) {
        <div class="message__content" role="button" tabindex="0"
             [class.new-notification]="!notification.readDate"
             (click)="markAsRead(notification)"
             (keydown.enter)="markAsRead(notification)"
             (keydown.space)="markAsRead(notification)">
          <div class="message__notification">
            <!-- notificationSubject/Body are plain strings (@k12/models Notifications), so Angular
                 auto-sanitizes these [innerHTML] bindings; kept as HTML since bodies contain real links. -->
            <div class="message__header" [class.text-bold]="!notification.readDate" [innerHTML]="notification.notificationSubject"></div>
            <div class="message__details">
              <span class="message__date-label" [matTooltip]="notification.sentDate | dateTimeFormatTooltip">
                {{ notification.sentDate | dateTimeFormat }}
              </span>
              @if (notification.readDate) {
                <button aria-label="Notification options"
                        class="message__right-button" disableRipple="true"
                        mat-button [matMenuTriggerFor]="menu"
                        (click)="$event.stopPropagation()">
                  <i class="fa-solid fa-ellipsis"></i>
                </button>
                <mat-menu #menu="matMenu" class="custom-notification-menu" xPosition="after">
                  <button disableRipple="true" mat-menu-item
                          (click)="markAsUnread(notification)">
                    <span>Mark As Unread</span>
                  </button>
                </mat-menu>
              }
            </div>
          </div>
           
          <div class="message-text message__hyperlink" [innerHTML]="notification.notificationBody"
               [class.text-bold]="!notification.readDate"
               tabindex="0" role="button"
               (click)="navigateLink($event)"
               (keyup.enter)="navigateLink($event)"
               (keyup.space)="navigateLink($event)">
          </div>
        </div>
      }
    }
  </div>
  <div
    class="show-text"
    role="button" tabindex="0"
    [attr.aria-label]="showMore ? 'Show less notifications' : 'Show more notifications'"
    (click)="showMore = !showMore"
    (keydown.enter)="showMore = !showMore"
    (keydown.space)="showMore = !showMore">
    <p class="show-hide">{{ showMore ? 'Show Less' : 'Show More' }}</p>
  </div>
</div>